var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1663 2.49999C18.3683 3.06289 17.4848 3.49341 16.5497 3.77499C16.0478 3.19791 15.3808 2.7889 14.6389 2.60326C13.897 2.41762 13.1159 2.46432 12.4014 2.73703C11.6869 3.00975 11.0734 3.49532 10.6438 4.12808C10.2143 4.76085 9.98942 5.51027 9.99967 6.27499V7.10832C8.5352 7.14629 7.08407 6.8215 5.77551 6.16286C4.46696 5.50422 3.34161 4.53218 2.49967 3.33332C2.49967 3.33332 -0.833658 10.8333 6.66634 14.1667C4.95011 15.3316 2.90564 15.9158 0.833008 15.8333C8.33301 20 17.4997 15.8333 17.4997 6.24999C17.4989 6.01787 17.4766 5.78632 17.433 5.55832C18.2835 4.71957 18.8837 3.66058 19.1663 2.49999Z",
    stroke: "#848494",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterGrey);
export default __webpack_public_path__ + "static/media/twitter-grey.8a4037b3.svg";
export { ForwardRef as ReactComponent };